export default "__VITE_ASSET__CMQ3wUa4__"